<template>
  <div class="blue window half-width info">
    <fieldset id="lp-info-currency">
      <legend>Currency reserves</legend>
      <ul id="balances-info">
          <li v-for="coin in currentPoolObj.coins">
              <b>{{coin.symbol}}: </b>
              <span v-if="(
                  typeof coin.poolBalance === 'undefined' ||
                  typeof coin.decimals === 'undefined' ||
                  typeof coin.usdPrice === 'undefined' ||
                  typeof currentPoolObj.usdTotal === 'undefined'
              )" class="loading line" />
              <span v-else>
                {{localNumber(truncWithXSignificantDecimals(coin.poolBalance / decimalsNumber(coin.decimals)))}} ({{trunc((coin.poolBalance / decimalsNumber(coin.decimals) * coin.usdPrice / currentPoolObj.usdTotal * 100), 2)}}%)
              </span>
          </li>
          <li>
            <b>USD total: </b>
            <span :class="{'loading line': (typeof currentPoolObj.usdTotal === 'undefined')}">
                <span v-if="typeof currentPoolObj.usdTotal !== 'undefined'">
                    <b>${{formatLargeNumber(currentPoolObj.usdTotal)}}</b>
                </span>
            </span>
          </li>
      </ul>
      <p>
        <ul>
            <li>
              <b>Daily USD volume: </b>
              <span v-if="typeof poolStats === 'undefined'" class="loading line" />
              <span v-else>
                <b>${{formatLargeNumber(poolStats.volumeUSD)}}</b>
              </span>
            </li>
            <li>
                <b>Liquidity utilization: </b>
                <span v-if="(typeof poolStats === 'undefined' || typeof currentPoolObj.usdTotal === 'undefined')" class="loading line" />
                <span v-else>
                    {{trunc((poolStats.volumeUSD / currentPoolObj.usdTotal * 100), 2)}}%
                </span>
                <span class='tooltip'> [?]
                  <span class='tooltiptext'>
                    24h Volume/Liquidity ratio
                  </span>
                </span>
            </li>
        </ul>
      </p>
      <p>
        <ul>
          <li>
            <b>Fee:</b>
            <span id='fee-info' :class="{'loading line': !fee}">
            </span>
            <span v-show = 'fee'> {{fee && truncWithoutZeroDecimals(fee, 3)}}</span>
          </span>%
          <li>
            <b>DAO fee:</b>
            <span id='admin-fee-info' :class="{'loading line': admin_fee === null}"> {{admin_fee && truncWithoutZeroDecimals(admin_fee, 3)}}</span>%
            <span v-show = 'admin_fee > 0'> of {{ fee && truncWithoutZeroDecimals(fee, 3) }}%</span>
            &nbsp;<span class="tooltip">[?]
              <span class="tooltiptext long">
                The total fee on each trade is split in two parts: one part goes to the pool’s Liquidity Providers, another part goes to the DAO (i.e. Curve veCRV holders)
              </span>
            </span>
          </li>
        </ul>
      </p>
      <p>
      <ul>
        <li>
          <b>
            Virtual price:
          </b>
          <span :class="{'loading line': virtualPrice1 === null}">
            <span class='tooltip'>
              {{ (virtualPrice1).toFixed(4) }}
              <span class='tooltiptext'>
                {{ virtualPrice1 }}
              </span>
            </span>
          </span>
          &nbsp;
          <span class='tooltip'>[?]
            <span class='tooltiptext'>
              Measures pool growth; this is not a dollar value
            </span>
          </span>
        </li>
        <li  v-if="!currentPoolObj.cryptoPool">
          <b class='tooltip'>
            A:
            <span class='tooltiptext long'>
              Amplification coefficient chosen from fluctation of prices around 1
            </span>
          </b>
          <span :class="{'loading line': A1 === null}"> {{ A1 }} </span>
        </li>
        <li v-if="!currentPoolObj.cryptoPool && isRampingUp">
          <b>Ramping up A:</b>
          <span> {{ initial_A }} -> {{ future_A1 }} </span>
          <span class='tooltip'>[?]
            <span class='tooltiptext long'>Slowly changing up A so that it doesn't negatively change virtual price growth of shares</span>
          </span>
        </li>
        <li v-if="!currentPoolObj.cryptoPool && isRampingUp">
          <b>Ramp up A ends on:</b>
          <span> {{ rampEnd }}</span>
        </li>
        <li  v-show = 'admin_actions_deadline1 !== null && admin_actions_deadline1 !== 0 && !currentPoolObj.cryptoPool && future_A1 != A1'>
          <b>Future A: </b>
          <span :class="{'loading line': future_A1 === null}"> {{ future_A1 }} </span>
        </li>
        <li v-show = 'admin_actions_deadline1 !== null && admin_actions_deadline1 !== 0 && !isFactory && !currentPoolObj.cryptoPool'>
          <b>Action deadline: </b>
          <div :class="{'loading line': admin_actions_deadline1 === null}">
            {{ admin_actions_readable }} GMT
            <span class='tooltip'> [?]
              <span class='tooltiptext long'>
                This is when the proposed future A can be enacted and changed.
                It also may not be changed.
              </span>
            </span>
          </div>
        </li>
      </ul>
  </p>
      <span v-if="currentPoolObj.cryptoPool">
      <legend>Price Data</legend>
      <p>
        <ul>
          <b>Price Oracle: </b>
          <li v-for='(currency, i) in Object.keys(currencies)'>
            <span v-show="i > hideKey">  {{currentPoolObj.isFactoryOnlyPool ?
            currencies[i][1] : coins[Array.from(Object.keys(currencies))[i]].symbol}}: {{ priceOracle[i-hideKey-1] }} </span>
          </li>
          <br />
          <b>Price Scale: </b>
          <li v-for='(currency, i) in Object.keys(currencies)'>
            <span v-show="i > hideKey">  {{currentPoolObj.isFactoryOnlyPool ?
            currencies[i][1] : coins[Array.from(Object.keys(currencies))[i]].symbol}}: {{ priceScale[i-hideKey-1] }} </span>
          </li>
        </ul>
      </p>
      <legend><b>Pool Parameters  </b></legend>

       <b>Gamma:
      </b>
        <span> {{ initial_A_gamma }} </span>

        <br>
        <b>   A:</b>

          <span> {{ A1 }} </span>
    </span>
    </fieldset>

    <fieldset id="lp-info-container" v-show='totalBalance && initializedContracts'>
      <legend  v-show="!currentPoolObj.cryptoPool">My share: ({{(totalBalance / totalBalances * 100).toFixed(3)}}% of pool)</legend>
      <legend  v-show="currentPoolObj.cryptoPool">My share: ({{(usdBalance / totalBalancesUsdValue * 100).toFixed(3)}}% of pool)</legend>

      <ul id='lp-info'>
          <li v-for='(currency, i) in Object.keys(currencies)'>
            <b>{{(
                currentPoolObj.isFactoryOnlyPool ?
                    currencies[i][1] :
                    coins[Array.from(Object.keys(currencies))[i]].symbol
            )}}:</b>
            <span> {{l_info && toFixed(l_info[i])}}</span></li>
          <li v-show="!currentPoolObj.cryptoPool">
            <b>{{allCurrenciesCopy}}:</b>
            <span :class="{'loading line': totalUserBalances === null}"> {{toFixed(totalUserBalances)}}</span>
          </li>
          <li  v-show="!currentPoolObj.cryptoPool && !currentPoolObj.isFactoryOnlyPool">
            <b>USD balance:</b>

            <span>
               <span :class="{'loading line': realShare === null}">
                <span v-show="realShare !== null">
                  {{realShare | toFixed2 | formatNumber}}
                </span>
              </span>
            </span>
          </li>
          <li   v-show="!currentPoolObj.cryptoPool && currentPoolObj.isFactoryOnlyPool">
            <b>Averaged
              <span>USD
              </span> balance:</b> {{ usdShare1 | formatNumber(2) }}
          </li>
          <li   v-show="currentPoolObj.cryptoPool && !currentPoolObj.isFakePlainPool">
            <b>Averaged
              <span>USD
              </span> balance:</b> {{ usdBalance | formatNumber(2) }}
          </li>
          <li   v-show="currentPoolObj.cryptoPool && currentPoolObj.isFakePlainPool">
            <b>Total
              <span>USD
              </span> balance:</b> {{ currentContract.usdShare | formatNumber(2) }}
          </li>
      </ul>
    </fieldset>
    <fieldset id="lp-info-container">
      <legend  v-show="totalStake > 0 && initializedContracts && !hideStakedShare">Staked share: ( {{(totalStake / totalBalances * 100).toFixed(3)}}% of pool)</legend>
      <ul id='stakelp-info'  v-show="totalStake > 0 && initializedContracts && !hideStakedShare" class="pbottom">
          <li v-for='(currency, i) in Object.keys(currencies)'>
            <b>{{(
                currentPoolObj.isFactoryOnlyPool ?
                    currencies[i][1] :
                    coins[Array.from(Object.keys(currencies))[i]].symbol
            )}}:</b>
            <span> {{staked_info && toFixed(staked_info[i])}}</span></li>
            <li v-show="!currentPoolObj.cryptoPool">
            <b>{{allCurrenciesCopy}}:</b>
            <span :class="{'loading line': totalStakedBalances === null}"> {{toFixed(totalStakedBalances)}}</span>
          </li>
          <li  v-show="!currentPoolObj.cryptoPool">
            <b>USD balance:</b>

            <span>
              <span :class="{'loading line': realStake === null}">
                <span v-show="realStake !== null">
                  {{realStake | toFixed2 | formatNumber}}
                </span>
              </span>
            </span>
          </li>

          <li   v-show="!currentPoolObj.isFakePlainPool">
            <b>Averaged
              <span>USD
              </span> balance:</b> {{ usdStake1 | formatNumber(2) }}
          </li>
          <li   v-show="currentPoolObj.isFakePlainPool">
            <b>Total
              <span>USD
              </span> balance:</b> {{ currentContract.usdStake | formatNumber(2) }}
          </li>

      </ul>
      <div v-if="userDetails">
        <legend>CRV Details:</legend><br />
        <ul>
            <li v-if="!areBoostsEnabled">
              <b>APY:</b> {{ (userDetails.CRVAPYs[0] || 0) | formatNumber(3) }}%
            </li>
            <li v-if="areBoostsEnabled">
              <b>Min APY:</b> {{ (userDetails.CRVAPYs[0] || 0) | formatNumber(3) }}%
            </li>
            <li v-if="areBoostsEnabled">
              <b>Max APY:</b> {{ userDetails.CRVAPYs[1] | formatNumber(3) }}%
            </li>
            <li v-show="areBoostsEnabled && totalStake > 0 && userDetails.CRVAPYs[3] > 0">
              <b>Your APY:</b> {{ userDetails.CRVAPYs[3] | formatNumber(3) }}% (Boost: {{ userDetails.boost | formatNumber(3) }})
            </li>
            <li v-show="areBoostsEnabled && totalStake > 0 && userDetails.CRVAPYs[3] > 0">
              <b>Future boost:</b> {{ userDetails.futureBoost | formatNumber(3) }}
              <span class='tooltip'>[?]
                <span class='tooltiptext long'>Your boost on a gauge is updated every time you interact with that gauge (staking, unstaking, or claiming CRV are all gauge interactions). Your current boost doesn’t change unless you interact with the gauge; the “future boost” displayed will become your current boost if you interact with the gauge.</span>
              </span>
            </li>
        </ul>
      </div>
    </fieldset>


  </div>
</template>

<script>
  import pools from '@/constants/pools'
  import coins from '@/constants/coins'
  import { getMainPoolsStats, getCryptoPoolsStats } from '@/utils/stats';
  import getPoolUsdFigure from '@/utils/data/getPoolUsdFigure';
  import Vue from 'vue'
  import { getters, allCurrencies, contract as currentContract } from '../contract'
  import { contractAbis, isFactoryAbiDataLoaded } from '@/constants/abis'
  import * as helpers from '../utils/helpers'
  import stableswap_fns from '../utils/stableswap_fns'
  import * as Comlink from 'comlink'
  import Worker from 'worker-loader!./graphs/worker.js';
  const worker = new Worker();
  const calcWorker = Comlink.wrap(worker);
  import * as priceStore from './common/priceStore'
  import config from '@/constants/config'
  import REFERENCE_ASSETS from '@/constants/reference-assets.js';
  import { getPricesArrayForTokens } from '../utils/data/getPricesForTokens'
  import getFactoryPools from '@/utils/data/getFactoryPools'
  import getCRVAPY, { getFactoCRVAPY } from '@/utils/data/getCRVAPY'
  import getStats from '@/utils/data/getAPY'
  import {
      formatLargeNumber,
      truncWithXSignificantDecimals,
      truncWithoutZeroDecimals,
      localNumber,
      decimalsNumber,
      trunc,
  } from '@/utils/Number'
  import { sleepUntil } from '@/utils/Async'
  import BN from 'bignumber.js'

  import EventBus from './graphs/EventBus'

  export default {
    props: ['pool', 'bal_info', 'total', 'l_info', 'totalShare', 'fee', 'admin_fee', 'tokenSupply', 'tokenBalance', 'usdShare', 'staked_info', 'totalStake', 'usdStake', 'combinedstats', 'virtual_price', 'A', 'future_A', 'admin_actions_deadline'],
    data: () => ({
      areBoostsEnabled: config.blockchainId === 'ethereum',
      REFERENCE_ASSETS,
      coins,
      currentContract,
      realShare: null,
      realStake: null,
      lastPoint: null,
      hideStakedShare: false,
      lastPool: null,
      loadingShares: false,
      usdRate: 0,
      coinPrices: null,
      totalBalancesUsdValue: null,
      usdBalance: null,
      userDetails: undefined,
      currentPoolObjData: undefined,
      poolStats: undefined,
    }),
    methods: {
      formatLargeNumber,
      truncWithXSignificantDecimals,
      truncWithoutZeroDecimals,
      localNumber,
      decimalsNumber,
      trunc,
      toFixed(num, precisions = 2, round = 4) {
          if(num == '' || num === null || num === undefined) return ''
          if(precisions == 2 && this.currentPoolObj.referenceAsset !== REFERENCE_ASSETS.USD) precisions = 8
          if (this.currentPoolObj.cryptoPool) precisions = 8
          let rounded = this.formatNumber(num, precisions)
          return rounded
      },
      formatNumber(number, dec = 2) {
        return helpers.formatNumber(number, dec)
      },
      async updateShares() {
          await this.updateTotalBalancesUsdValue();

        if(this.currentPoolObj.isFactoryOnlyPool) return; // The info returned from this fn isn't displayed for factory-only pools
        if(!(this.usdShare1 > 0 || (this.usdStake1) > 0)) return;
        let poolId = this.currentPool

        poolId = poolId == 'iearn' ? 'y' : poolId == 'susdv2' ? 'susd' : (config.blockchainId === 'ethereum' && poolId == 'ren') ? 'ren2' : poolId == 'sbtc' ? 'rens' : poolId


        let apiUrl = `${window.domain}/${config.rawStatsPath}/${poolId}-1m.json`

        if (this.currentPoolObj.cryptoPool) {
          apiUrl = `${window.domain}/${config.rawStatsPath}-crypto/${poolId}-1m.json`
        }

        let req = await fetch(apiUrl)

        this.lastPoint = await req.json()
        this.lastPoint = this.lastPoint[this.lastPoint.length - 1]

        let N_COINS = contractAbis[this.currentPool].N_COINS;
        if(this.loadingShares) return;
        let prices = new Array(N_COINS).fill(1)
        for(let i = 0; i < N_COINS; i++) {
          // TODO post-refactoring
          // Make precisions dynamic; none of the precision lists available in
          // current abi configs match what's expected here
          if(i == 1) continue
          let amount = 1
          let toPrecisions = 1e6
          if(['tbtc', 'ren', 'sbtc', 'hbtc', 'pbtc', 'bbtc', 'obtc'].includes(this.currentPool)) {
            amount = 0.0001
            toPrecisions = 1e8
          }
          if(contractAbis[this.currentPool].is_meta || this.currentPool == 'eurs' || this.currentPool == 'seth' || this.currentPool == 'steth' || this.currentPool == 'ankreth' || this.currentPool == 'reth') {
            toPrecisions = 1e18
          }
          if(['saave', 'link'].includes(this.currentPool)) {
            toPrecisions = 1e18
          }



          let dy = await calcWorker.calcPrice({
            ...this.lastPoint,
            N_COINS: contractAbis[this.currentPool].N_COINS,
            PRECISION_MUL: contractAbis[this.currentPool].coin_precisions.map(p=>1e18/p),
            PRECISION: 1e18,
          }, i, 1, amount * contractAbis[this.currentPool].coin_precisions[i])
          let price = dy / toPrecisions / amount
          prices[i] = price
        }
        if(this.loadingShares) return;
        this.loadingShares = true
        this.realShare = 0;
        this.realStake = 0;
        for(let i = 0; i < N_COINS; i++) {
          this.realShare += +this.l_info[i] * prices[i]
          this.realStake += +this.staked_info[i] * prices[i]
        }

        this.realShare = await getPoolUsdFigure(this.realShare, this.currentPoolObj);
        this.realStake = await getPoolUsdFigure(this.realStake, this.currentPoolObj);
        this.loadingShares = false
      },
      async updateTotalBalancesUsdValue() {
        const isCryptoPool = this.currentPoolObj.cryptoPool;

        if (isCryptoPool) {
            if (this.cryptoCoinPrices) {
                this.totalBalancesUsdValue = this.bal_info && this.bal_info.reduce((a, b, i) => a + (b * this.cryptoCoinPrices[i]), 0) || null;
            }
            this.usdBalance =  getters.usdShare()
        } else {
            const totalBalances = this.totalBalances;
            this.totalBalancesUsdValue = totalBalances === null ? null : (totalBalances * this.usdRate);
        }
      },
    },
    async created() {
      sleepUntil(() => pools.isFactoryPoolDataLoaded() && isFactoryAbiDataLoaded()).then(() => {
          this.currentPoolObjData = pools.getById(this.currentPool);
      })

      let key = this.currentPool == 'iearn' ? 'y' : this.currentPool == 'susdv2' ? 'susd' : this.currentPool

        const CRV_DETAILS = (
            config.blockchainId === 'ethereum' ?
                await getCRVAPY(currentContract.default_account, true) :
                await getFactoCRVAPY(currentContract.default_account, true)
        );
        const hasCrvDetails = key in CRV_DETAILS.CRVAPYs;

        if (hasCrvDetails) {
            this.userDetails = {
                CRVAPYs: CRV_DETAILS.CRVAPYs[key],
                boost: CRV_DETAILS.boosts[key],
                futureBoost: CRV_DETAILS.futureBoosts[key],
            };
        }


      if (this.currentPoolObj.hasNoGauge) this.hideStakedShare = true
      if (this.currentPoolObj.cryptoPool) {
        this.coinPrices = await getPricesArrayForTokens(this.currentPoolObj.coins.map(({ address }) => address));
      }

      this.hasLoadedInfo && this.updateShares()
      this.$watch(() => this.hasLoadedInfo, val => this.updateShares())
      EventBus.$on('updateShares', () => {
        this.updateShares()
      })

      this.poolStats = {
          volumeUSD: this.currentPoolObj.isFactoryOnlyPool ? this.currentPoolObj.volume : (await getStats()).volumes[this.currentPoolObj.id][0],
      };
    },
    async updated() {
        this.usdRate = await getPoolUsdFigure(1, this.currentPoolObj);
        console.log('updated', this.usdRate)
        this.updateTotalBalancesUsdValue();
    },
    computed: {
        currentPoolObj() {
            return this.currentPoolObjData || pools.getById(this.currentPool);
        },
        allCurrenciesCopy() {
            return this.currentPoolObj.isFactoryOnlyPool ?
                this.currentPoolObj.coins.map(({ symbol }) => symbol).join('+'):
                Array.from(Object.keys(this.currencies)).map((id) => coins[id].symbol).join('+');
        },

        currencies() {
            let currencies;

            if (this.currentPoolObj.isFactoryOnlyPool) {
                const { coins, metaCoins } = this.currentPoolObj;
                const factoryCurrencies = coins;

                currencies = factoryCurrencies.map(({ symbol }, i) => [i, symbol]);
            } else {
                if (this.currentPoolObj.isLendingPool) return getters.lending_currencies();
                currencies = getters.currencies()
            }
            return currencies;
        },
        hideKey() {
          //fucking mess to hide first coins in a fake crypto metapool, on crypto pools we hide some price data for the first x coins
          let hideKey = 0
          if (this.currentPoolObj.isFakePlainPool) {
            hideKey = 2
          }

          return hideKey;
        },
        // Only works for crypto pools with 2 coins, can improve later to support more
        cryptoCoinPrices() {
            if (this.coinPrices === null) return null;

            return this.coinPrices.map((price, i) => (
                (typeof price === 'undefined' && this.coinPrices.length === 2) ? (
                    i === 0 ? this.coinPrices[1] / this.priceOracle :
                        this.coinPrices[0] * this.priceOracle
                ) : price
            ));
        },
      showShares: getters.showShares,
      initializedContracts: getters.initializedContracts,
      totalSupply() {
        if(this.tokenSupply) return this.tokenSupply
        return getters.totalSupply()
      },
      totalBalance() {
        if(this.tokenBalance) return this.tokenBalance
        return getters.totalBalance()
      },
      curveStakeBalance() {
        return currentContract.curveStakeBalance
      },
      isFactory() {
        return currentContract.is_factory
      },
      priceOracle() {
        return currentContract.priceOracle
      },
      priceScale() {
        return currentContract.priceScale
      },
      initial_A_gamma() {
          if (!currentContract.initial_A_gamma) return;
          let aGamma = BigInt(currentContract.initial_A_gamma) & BigInt(BN(2).pow(128).minus(1).toFixed())
          return BN(aGamma).div(1e18).toFixed(10)
      },
      volumePool() {
        return this.currentPool == 'iearn' ? 'y' : this.currentPool == 'susdv2' ? 'susd' : this.currentPool
      },
      currentPool() {
        return this.pool || currentContract.currentContract
      },
      virtualPrice1() {
        return this.virtual_price || (currentContract.virtual_price || 0)
      },
      totalBalances() {
        return this.bal_info && this.bal_info.reduce((a, b) => a + b, 0) || null
      },
      totalUserBalances() {
        return this.l_info && this.l_info.reduce((a, b) => a + b, 0) || null
      },
      totalStakedBalances() {
        return this.staked_info && this.staked_info.reduce((a, b) => a + b, 0) || null
      },
      usdShare1() {
        let share = (this.usdShare || getters.usdShare())
        return share * this.usdRate;
      },
      usdStake1() {
        let stake =  (this.usdStake || getters.usdStake())
        if (this.currentPoolObj.cryptoPool) return stake; // Usd values taken into account while generated usdStake value
        else return stake * this.usdRate;
      },
      A1() {
        return this.A || ((getters.A() * 1e18) | 0)
      },
      future_A1() {
          const multiplier = (this.currentPoolObj.hasAMultiplier)?100:1;
          return this.future_A / multiplier || ((getters.future_A()) | 0) / multiplier
      },
      initial_A() {
          const multiplier = (this.currentPoolObj.hasAMultiplier)?100:1;
          return getters.initial_A() / multiplier
      },
      isRampingUp() {
        const now = Date.now() / 1000;
        return getters.initial_A_time() < now && now < getters.future_A_time();
      },
      rampEnd() {
        return helpers.formatDateToHuman(getters.future_A_time())
      },
      admin_actions_readable() {
        return helpers.formatDateToHuman(this.admin_actions_deadline1)
      },
      admin_actions_deadline1() {
        return this.admin_actions_deadline || getters.admin_actions_deadline()
      },
      hasLoadedInfo() {
        let N_COINS = contractAbis[this.currentPool].N_COINS;
        return this.currentPool && (this.l_info && this.l_info[N_COINS-1] !== undefined) || (this.staked_info && this.staked_info[N_COINS - 1] !== undefined)
      },
    }
  }
</script>

<style scoped>
  .tooltip {
    margin-left: 0;
  }

  .tooltip .tooltiptext {
    font-weight: normal;
    background-color: #aaaaaa;
    color: black;
  }
  .tooltip .tooltiptext::after {
    border-color: #aaaaaa transparent transparent transparent;
  }
  .pbottom {
    margin-bottom:15px;
  }
</style>
